module.exports = __webpack_public_path__ + "img/teams.946fe37b.svg";